class Video {
  constructor() {
    this.video = document.querySelectorAll('.media-block__video video');
    this.playBtn = document.querySelectorAll('.media-block__play');

    this.events();
  }

  // Events
  events() {
    this.playBtn.forEach((btn) => {
      btn.addEventListener('click', this.play.bind(this));
    });

    this.video.forEach((videoEl) => {
      videoEl.addEventListener('click', this.pause.bind(this));
    });
  }

  // Methods
  play(e) {
    e.preventDefault();

    e.target.closest('.media-block__video').classList.add('video--active');

    const video = e.target.closest('.media-block__video').querySelector('video');
    video.play();
  }

  pause(e) {
    e.preventDefault();

    e.target.closest('.media-block__video').classList.remove('video--active');
    e.target.pause();
  }
}

///////////////////////////////
// jQuery
// Smooth scroll to anchor when arriving from another page (prevents browser jump)
(function () {
  var hash = window.location.hash;
  if (hash) {
    var targetId = decodeURIComponent(hash.replace('#', ''));

    // Remove hash from URL without triggering a jump
    if (history && history.replaceState) {
      history.replaceState(null, '', window.location.pathname + window.location.search);
    } else {
      window.location.hash = '';
    }

    // Ensure we start at top so the browser doesn't auto-jump later
    window.scrollTo(0, 0);

    $(window).on('load', function () {
      var el = document.getElementById(targetId);
      if (el) {
        // small delay to let layout/images settle, then smooth scroll
        setTimeout(function () {
          $('html, body').animate(
            {
              scrollTop: $(el).offset().top - 100,
            },
            700,
          );
        }, 300);
      }
    });
  }

  // In-page anchor smooth scroll
  $(document).on('click', 'a[href^="#"]', function (event) {
    var href = $.attr(this, 'href');
    var id = href.replace('#', '');
    var el = document.getElementById(id);
    if (el) {
      event.preventDefault();
      $('html, body').animate(
        {
          scrollTop: $(el).offset().top - 100,
        },
        500,
      );
    }
  });
})();

$(function () {
  var topPadding = $('.header').outerHeight();

  $('body').css('padding-top', topPadding + 'px');
  // Toggler
  $('.toggler').on('click', function (event) {
    $(this).toggleClass('toggler--active');
    $('.mobile-menu').toggleClass('active');
  });

  if (document.querySelector('.media-block__video')) {
    const video = new Video();
  }

  if ($('.swiper-banner').length) {
    var swiperBanner = new Swiper('.swiper-banner', {
      loop: true,
      grabCursor: true,
      allowTouchMove: true,
      autoplay: false,
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: '.swiper-banner .swiper-pagination',
        clickable: true,
      },
    });
  }

  var swiperText = new Swiper('.swiper-text', {
    effect: 'fade',
    loop: true,
    grabCursor: true,
    autoplay: false,
    allowTouchMove: false,
    grabCursor: false,
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: '.swiper-text .swiper-pagination',
      clickable: true,
    },
  });

  document.querySelectorAll('.grey-box').forEach((section) => {
    const imageSlider = section.querySelector('.grey-box__top .grey-box-slider');
    const contentSlider = section.querySelector('.grey-box__bottom .grey-box-slider');

    if (!imageSlider || !contentSlider) return;

    const imageSwiper = new Swiper(imageSlider, {
      effect: 'fade',
      loop: true,
      fadeEffect: {
        crossFade: true,
      },
    });

    const contentSwiper = new Swiper(contentSlider, {
      loop: true,
      grabCursor: true,
      navigation: {
        nextEl: section.querySelector('.swiper-next'),
        prevEl: section.querySelector('.swiper-prev'),
      },
      controller: {
        control: imageSwiper,
      },
      on: {
        init: function () {
          updateSlideCount(this);
        },
        slideChange: function () {
          updateSlideCount(this);
        },
      },
    });

    imageSwiper.controller.control = contentSwiper;
  });

  function updateSlideCount(swiper) {
    const container = swiper.el;

    const current = container.querySelector('.swiper-slide-count .current');
    const total = container.querySelector('.swiper-slide-count .total');

    if (!current || !total) return;

    const realSlides = swiper.slides.filter((slide) => !slide.classList.contains('swiper-slide-duplicate'));

    current.textContent = swiper.realIndex + 1;
    total.textContent = realSlides.length;
  }

  var swiperCards = new Swiper('.swiper-cards', {
    effect: 'cards',
    grabCursor: true,
    allowTouchMove: false,
    grabCursor: false,
    cardsEffect: {
      perSlideOffset: 6, // Default is 8, increase for more spacing
      perSlideRotate: 4, // Adjust if you want less/more rotation
    },

    pagination: {
      el: '.swiper-text .swiper-pagination',
      clickable: true,
    },
  });

  // //Homepage Testimonials move pagination under image

  // if ($(window).width() <= 991) {
  //   $('.swiper-pagination').appendTo('.swiper-cards');
  // } else {
  //   $('.swiper-pagination').appendTo('.swiper-text');
  // }
  if ($('.contact-page').length || $('.single-program-page').length) {
    $('.footer .footer__wrap').remove();
  }

  function formValidation(e) {
    var isValid = true;
    var $form = $(this);

    // Example: required fields with [required] attribute
    $form.find('[required]').each(function () {
      if (!$(this).val().trim()) {
        isValid = false;
        $(this).addClass('input-error');
      } else {
        $(this).removeClass('input-error');
      }
    });

    // Example: email validation
    var $email = $form.find('input[type="email"]');
    if ($email.length) {
      var emailVal = $email.val().trim();
      var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(emailVal)) {
        isValid = false;
        $email.addClass('input-error');
      } else {
        $email.removeClass('input-error');
      }
    }

    if (!isValid) {
      e.preventDefault();
      // Optionally show a message
      if (!$form.find('.form-error-message').length) {
        $form.prepend('<div class="form-error-message">Popunite obavezna polja.</div>');
      }
    } else {
      $form.find('.form-error-message').remove();
    }
  }

  // if ($('.footer .footer__wrap form').length) {
  //   $('.footer .footer__wrap form').on('submit', formValidation);
  // }

  if ($('.grey-box__form form').length) {
    $('.grey-box__form form').on('submit', formValidation);
  }

  if ($('.contact-page').length) {
    if ($('.shopify-app-block').closest('section').next('section').find('.big-map').length) {
      $('.shopify-app-block')
        .closest('section')
        .next('section')
        .prev('section')
        .addBack()
        .wrapAll('<div class="contact-page-wrap"></div>');
    }
  }
});
